import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {Observable} from 'rxjs';
import {FirestoreService} from '../../../services/firestore.service';
import { AuthService } from '../../../services/auth.service';
import { CartService } from '../../../services/cart.service';

@Component({
    selector: 'site-header',
    templateUrl: './site-header.component.html',
    styleUrl: './site-header.component.scss',
    standalone: false
})
export class SiteHeaderComponent {
	page: string;
  navBar$: Observable<Object>;
  navBar: Iterable<any> = [];

	constructor(
		private route: ActivatedRoute,
		private router: Router,
    	private firestoreService: FirestoreService,
		private authService: AuthService,
		private cartService: CartService
	) {
		this.page = this.router.url;
		this.navBar$ = this.firestoreService.getSiteNav('navBar');
		this.navBar$.subscribe((value: any) => { this.navBar = value });
	}

	showBanner(): boolean {
		return this.router.routerState.snapshot.url === '/';
	}

	isAuthenticated(): boolean {
		return this.authService.isAuthenticated();
	}

	isAdmin(): boolean {
		return this.authService.hasRole('admin');
	}

	isCartEmpty(): boolean {
		return this.cartService.isEmpty();
	}

	logout() {
		this.authService.logout();
		this.router.navigateByUrl('/login');
	}

	navigate(url: string) {
		 this.router.navigate([url]);
	}
}
